import crypto from 'crypto';

import Store from '../flux/Store';

import config from '../config';
import mapActions from '../actions/map';
import tooltipActions from '../actions/tooltip';
import zoomerActions from '../actions/zoomer';

import { parse } from '../utils/parsers';

var debounce = {
  zoom:  undefined,
  hover: undefined,
  pan:   undefined
};

/** @class TooltipStore */
class TooltipStore extends Store {

  init () {
    tooltipActions.on(tooltipActions.EVENTS.HOVER_ENTER, this.enterHover.bind(this));
    tooltipActions.on(tooltipActions.EVENTS.HOVER_LEAVE, this.leaveHover.bind(this));

    zoomerActions.on(zoomerActions.EVENTS.START, this.startPan.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.END, this.endPan.bind(this));
    zoomerActions.on(zoomerActions.EVENTS.ZOOM, this.onZoom.bind(this));

    mapActions.on(mapActions.EVENTS.SECTION_TOGGLE, this.leaveHover.bind(this));
  }

  // TOOLTIP ACTIONS
  // -------------------------------------------------------------------------------------------------------
  // HOVER
  enterHover (hover) {
    var parsedData = parse('tooltip', hover.type, hover.el.props);

    if (parsedData && parsedData.type) {
      this.data.props = parsedData;
      this.data.el = hover.el;

      this.debounceAnimation('hover', 'isHovering');
    }
  }

  leaveHover () {
    this.data.props = null;
    this.data.el = null;
    this.done();
  }

  startPan () {
    this.data.isPanning = true;
    this.done();
  }

  endPan () {
    this.debounceAnimation('pan', 'isPanning');
  }

  onZoom () {
    this.debounceAnimation('zoom', 'isZooming');
  }

  debounceAnimation (timeout, prop) {
    clearTimeout(debounce[timeout]);

    debounce[timeout] = setTimeout(function () {
      this.data[prop] = false;
      this.done();
    }.bind(this), 150);

    if (!this.data[prop]) {
      this.data[prop] = true;
      this.done();
    }
  }
}

/** @type {TooltipStore} */
export default new TooltipStore({
  isHovering: false,
  isPanning:  false,
  isZooming:  false,
  data:       null,
  el:         null
});



// WEBPACK FOOTER //
// ./frontend/react/sim/core/stores/tooltip.js